'use client';
import styles from './AnswerQuestions.module.scss';
import Image from 'next/image';
import QAImage from '@/public/assets/Images/QA.svg';
import { useState } from 'react';
import { useTranslations } from 'next-intl';

export const AnswerQuestions = () => {
  const t = useTranslations('ui.answerQuestions');
  const AQData = [
    {
      question: t('first.question'),
      answer: t('first.answer'),
    },
    {
      question: t('second.question'),
      answer: t('second.answer'),
    },
    {
      question: t('third.question'),
      answer: t('third.answer'),
    },
  ];

  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="qa" className={styles.container}>
      <figure>
        <Image
          src={QAImage}
          alt="question answer qa"
          width={466}
          height={489}
        />
      </figure>
      <div className={styles.content}>
        <h2>{t('title')}</h2>
        <div className={styles.questionsWrapper}>
          {AQData.map((el, i) => (
            <div
              key={i}
              className={styles.item}
              onClick={() => setOpen(open === i ? null : i)}
            >
              <div
                className={`${styles.question} ${
                  open === i ? styles.question_active : ''
                }`}
              >
                <h6>{el.question}</h6>
                <div className={styles.iconWrapper}>
                  {open === i ? (
                    <span className={styles.minus}>-</span>
                  ) : (
                    <span className={styles.plus}>+</span>
                  )}
                </div>
              </div>
              {open === i && (
                <div
                  className={styles.answer}
                  onClick={(e) => e.stopPropagation()}
                >
                  {el.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
